import React from 'react';
import { FaqDialog } from './FaqDialog';

export function useFaqDialog(): [() => void, React.ReactNode] {
  const [open, setOpen] = React.useState(false);
  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  const dialog = <FaqDialog open={open} onClose={hide} />;

  return [show, dialog];
}
